import React, { useContext, useMemo } from 'react';
import { Trans } from 'react-i18next';
import { vehicleContext } from '../VehicleProvider';
import { VehicleDetails } from '../../types';

const PriceLabel: React.FC = () => {
  const { vehicle } = useContext(vehicleContext);
  const { market, isAvailableNow } = (vehicle as VehicleDetails) ?? {};

  const translationKey = useMemo(() => {
    if (market === 'ca' && !isAvailableNow)
      return 'vehiclePricingBar.dealerListPrice.dealerListPrice';

    if (market === 'ca' && isAvailableNow)
      return 'vehiclePricingBar.dealerListPrice.dealerListPrice';

    if (market === 'cauc') return 'vehiclePricingBar.dealerListPrice.dealerListPrice';

    if (market === 'us') return 'vehiclePricingBar.dealerListPrice.msrpDestinationFeeUSA';

    // market === 'usuc'
    return 'vehiclePricingBar.dealerListPrice.dealerPrice';
  }, [market, isAvailableNow]);

  return (
    <Trans
      i18nKey={translationKey}
      // the global reset css imported in several feature apps
      // contains globally applied oppinionated styling
      components={{ bold: <span style={{ fontWeight: 'bold' }} /> }}
    />
  );
};

export default PriceLabel;
